var render = function render(_c,_vm){return _c('v-row',{staticClass:"mb-10 mb-16 py-5",attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center mt-16 mx-auto",attrs:{"align":"center","col":"auto","id":"banner"}},[_c('div',{staticClass:"banner_text text-center"},[_vm._v(_vm._s(_vm.props.title))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }